export const requiredPasswordLength = 8;
export const requiredNumbers = 1;
export const requiredSpecialChars = 1;
export const requiredUppercaseChars = 1;
export const requiredLowercaseChars = 1;

export const passwordValidationRules = {
  hasLength: /^.{8,}$/,
  hasNumber: /\d/,
  hasSpecialCharacter: /[!@#$%^&*)(+=._-]/,
  hasUppercase: /[A-Z]/,
  hasLowercase: /[a-z]/,
};
